import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { Box, Button, Typography } from '@mui/material';

import { caloTheme } from '../../assets/themes/calo';
import type { TodayProgress } from '../../libs';
import { chefText, primaryButtonSx, quietLinkSx, tabular } from '../chefStyles';
import FocusedHeading from '../FocusedHeading';

const { palette } = caloTheme;

type AllDoneProps = {
  progress: TodayProgress;
  moreWaiting: boolean;
  onMore: () => void;
  onLeave: (() => void) | undefined;
};

// Shown once the day's goal is met.
const AllDone = ({ progress, moreWaiting, onMore, onLeave }: AllDoneProps) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 1, py: 8 }}>
    <CheckCircleOutlinedIcon sx={{ fontSize: { xs: 48, md: 64 }, color: palette.primary800 }} />
    <FocusedHeading>Today's {progress.goal} done</FocusedHeading>
    {progress.kitchenChecked > 0 && (
      <Typography sx={{ ...chefText.body, color: palette.neutral800, ...tabular }}>
        {`Your kitchen checked ${progress.kitchenChecked} ${progress.kitchenChecked === 1 ? 'clip' : 'clips'} today.`}
      </Typography>
    )}
    <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
      {onLeave !== undefined && (
        <Button variant="contained" sx={primaryButtonSx} onClick={onLeave}>
          Back to KDS
        </Button>
      )}
      {moreWaiting && (
        <Button variant="text" sx={quietLinkSx} onClick={onMore}>
          More clips are waiting ›
        </Button>
      )}
    </Box>
  </Box>
);

export default AllDone;
